module.exports = {

	methods: {
		getSavedData: function() {

		},

		setSavedUrl(id){
			
		}

	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/savedData.js